import React, { FC, Fragment } from 'react';
import { Button, Typography } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import { Trans } from 'react-i18next';

import { useCurrentUser } from 'hooks';
import { Logout } from 'Links';
import { Main } from 'features/auth/components';
import { ActionContainer, ClientLogo, Layouts } from 'components';
import { getAppImage } from 'helpers';
import { APP_IMAGES } from 'constants/index';

const styles = (theme: Theme) =>
  createStyles({
    logo: {
      marginBottom: theme.spacing(1),
    },
    button: {
      width: 250,
      marginBottom: theme.spacing(3),
      textAlign: 'center',
    },
  });

interface IProps extends WithStyles<typeof styles> {}

const LocationBlock: FC<IProps> = ({ classes }) => {
  const currentUser = useCurrentUser();

  function renderSidebar() {
    return (
      <Fragment>
        <ClientLogo />
        <Typography variant="h4" color="textSecondary">
          {currentUser.location.block_message}
        </Typography>
        <div className={classes.logo}>
          <img {...getAppImage(APP_IMAGES.Logo)} />
        </div>
        <ActionContainer>
          <Button
            component={Logout}
            className={classes.button}
            size="large"
            variant="contained"
            color="secondary">
            <Trans i18nKey="common:logout" />
          </Button>
        </ActionContainer>
      </Fragment>
    );
  }

  return (
    <Layouts.Full2Column
      sidebar={renderSidebar()}
      main={<Main headerI18nKey="auth:bodyHeader1" subHeaderI18nKey="auth:signUpSubHeader" />}
    />
  );
};

export default withStyles(styles)(LocationBlock);
